<div class="admin-container">
  <!-- Header principal -->
  <!-- <div class="page-header">
    <div class="header-content">
      <h1>Administración de Contenido</h1>
      <p>Gestiona videos y papers de la plataforma</p>
    </div>
  </div> -->

  <!-- Sistema de pestañas -->
  <div class="tabs-container">
    <div class="tabs-header">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'videos'"
        (click)="setActiveTab('videos')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M8 9l4 3-4 3V9z" fill="currentColor"/>
        </svg>
        Administración de Videos
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'papers'"
        (click)="setActiveTab('papers')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M6 6h8M6 10h8M6 14h4" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Administración de Papers
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'academy-categories'"
        (click)="setActiveTab('academy-categories')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 4h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M6 8h8M6 12h6" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="5" cy="8" r="1" fill="currentColor"/>
          <circle cx="5" cy="12" r="1" fill="currentColor"/>
        </svg>
        Categorías de Academy
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'expert-categories'"
        (click)="setActiveTab('expert-categories')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M4 18c0-4 2.7-7 6-7s6 3 6 7" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M14 6l2 2-2 2M6 6L4 8l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Categorías de Expertos
      </button>
    </div>

    <!-- Contenido de la pestaña de Videos -->
    <div class="tab-content" *ngIf="activeTab === 'videos'">
      <div class="tab-header">
        <div class="tab-title">
          <h2>Administración de Videos</h2>
          <p>Gestiona los videos y cursos de la plataforma</p>
        </div>
        <button class="add-button" (click)="openVideoForm()">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Nuevo Video
        </button>
      </div>
      
      <div class="filters-bar">
        <div class="search-box">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input 
            type="text" 
            [(ngModel)]="searchTerm" 
            (input)="applyFilters()"
            placeholder="Buscar videos..."
          >
        </div>
        
        <div class="category-filter">
          <label for="category-select">Categoría:</label>
          <select 
            id="category-select" 
            [(ngModel)]="selectedCategory" 
            (change)="applyFilters()"
          >
            <option value="all">Todas las categorías</option>
            <option *ngFor="let category of videoCategories" [value]="category.id">{{category.name}}</option>
          </select>
        </div>
      </div>
      
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th class="thumbnail-col">Miniatura</th>
              <th class="title-col">Título</th>
              <th class="category-col">Categoría</th>
              <th class="duration-col">Duración</th>
              <th class="price-col">Precio</th>
              <th class="featured-col">Destacado</th>
              <th class="views-col">Vistas</th>
              <th class="date-col">Fecha</th>
              <th class="actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let video of getPageVideos()">
              <td class="thumbnail-col">
                <div class="video-thumbnail" (click)="openVideoPreview(video.videoUrl)">
                  <img [src]="video.thumbnailUrl" alt="Thumbnail">
                  <div class="play-overlay">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="12" fill="currentColor" opacity="0.7"/>
                      <path d="M9 7l8 5-8 5V7z" fill="white"/>
                    </svg>
                  </div>
                </div>
              </td>
              <td class="title-col">
                <div class="video-title">{{video.title}}</div>
                <div class="video-description">{{video.description | slice:0:100}}{{video.description.length > 100 ? '...' : ''}}</div>
              </td>
              <td class="category-col">{{getCategoryName(video.category)}}</td>
              <td class="duration-col">{{video.duration}}</td>
              <td class="price-col">
                <span *ngIf="!video.isFree">S/.{{video.price}}</span>
                <span *ngIf="video.isFree" class="free-label">Gratis</span>
              </td>
              <td class="featured-col">
                <button class="featured-toggle" [class.featured]="video.featured" (click)="video._id && toggleVideoFeatured(video._id)">
                  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 4-1z" fill="none" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </button>
              </td>
              <td class="views-col">{{video.views}}</td>
              <td class="date-col">{{video.updatedAt | date:'dd/MM/yyyy'}}</td>
              <td class="actions-col">
                <div class="action-buttons">
                  <button class="edit-button" (click)="openVideoForm(video)" title="Editar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1l3 3-9 9-3 1 1-3z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                  <button class="delete-button" (click)="video._id && deleteVideo(video._id)" title="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 5h10M5 5V3h6v2M5 5v8h6V5" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            
            <tr *ngIf="getPageVideos().length === 0">
              <td colspan="9" class="empty-state">
                <div class="empty-message">
                  <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                    <rect x="8" y="12" width="32" height="24" rx="4" stroke="currentColor" stroke-width="2" fill="none"/>
                    <path d="M20 24l10 6-10 6V24z" fill="currentColor"/>
                  </svg>
                  <p>No se encontraron videos</p>
                  <button class="add-button" (click)="openVideoForm()">Agregar nuevo video</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="pagination" *ngIf="filteredVideos.length > 0">
        <button 
          class="pagination-button" 
          [disabled]="currentPage === 1" 
          (click)="changePage(currentPage - 1)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3l-4 5 4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        
        <div class="page-indicator">
          Página {{currentPage}} de {{getTotalPages()}}
        </div>
        
        <button 
          class="pagination-button" 
          [disabled]="currentPage === getTotalPages()" 
          (click)="changePage(currentPage + 1)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 3l4 5-4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Contenido de la pestaña de Papers -->
    <div class="tab-content" *ngIf="activeTab === 'papers'">
      <div class="tab-header">
        <div class="tab-title">
          <h2>Administración de Papers</h2>
          <p>Gestiona los papers y documentos de la plataforma</p>
        </div>
        <button class="add-button" (click)="openPaperForm()">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Nuevo Paper
        </button>
      </div>
      
      <div class="filters-bar">
        <div class="search-box">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input 
            type="text" 
            [(ngModel)]="paperSearchTerm" 
            (input)="applyPaperFilters()"
            placeholder="Buscar papers..."
          >
        </div>
        
        <div class="category-filter">
          <label for="paper-category-select">Categoría:</label>
          <select 
            id="paper-category-select" 
            [(ngModel)]="selectedPaperCategory" 
            (change)="applyPaperFilters()"
          >
            <option value="all">Todas las categorías</option>
            <option *ngFor="let category of paperCategories" [value]="category.id">{{category.name}}</option>
          </select>
        </div>
        
        <div class="category-filter">
          <label for="paper-status-select">Estado:</label>
          <select 
            id="paper-status-select" 
            [(ngModel)]="selectedPaperStatus" 
            (change)="applyPaperFilters()"
          >
            <option value="all">Todos los estados</option>
            <option [value]="1">Activo</option>
            <option [value]="2">Inactivo</option>
            <option [value]="3">En revision</option>
            <option [value]="4">Borrador</option>
          </select>
        </div>
      </div>
      
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th class="thumbnail-col">Portada</th>
              <th class="title-col">Título</th>
              <th class="category-col">Categoría</th>
              <th class="author-col">Autor</th>
              <th class="status-col">Estado</th>
              <th class="featured-col">Destacado</th>
              <th class="downloads-col">Descargas</th>
              <th class="date-col">Fecha</th>
              <th class="actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let paper of getPagePapers()">
              <td class="thumbnail-col">
                <div class="paper-thumbnail" (click)="openPaperPreview(paper)">
                  <img 
                    [src]="getPaperCoverUrl(paper.coverUrl)" 
                    alt="Portada"
                    (error)="onImageError($event)"
                    (load)="onImageLoad($event)"
                  >
                  <div class="document-overlay">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                      <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="1.5"/>
                    </svg>
                  </div>
                </div>
              </td>
              <td class="title-col">
                <div class="paper-title">{{paper.title}}</div>
                <div class="paper-description">{{paper.description | slice:0:100}}{{paper.description.length > 100 ? '...' : ''}}</div>
              </td>
              <td class="category-col">
                <div class="paper-categories-list">
                  <span 
                    class="category-tag-small" 
                    *ngFor="let category of getPaperCategoriesArray(paper)"
                    [title]="category.name"
                  >
                    {{category.name}}
                  </span>
                  <span *ngIf="getPaperCategoriesArray(paper).length === 0" class="no-category">
                    Sin categoría
                  </span>
                </div>
              </td>
              <td class="author-col">{{getExpertName(paper.author)}}</td>
              <td class="status-col">
                <span class="status-badge" [ngClass]="'status-' + getPaperStatusClass(paper)">
                  {{ getPaperStatus(paper) }}
                </span>
              </td>
              <td class="featured-col">
                <button class="featured-toggle" [class.featured]="paper.featured" (click)="paper._id && togglePaperFeatured(paper._id)">
                  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 4-1z" fill="none" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </button>
              </td>
              <td class="downloads-col">{{paper.downloads}}</td>
              <td class="date-col">{{paper.updatedAt | date:'dd/MM/yyyy'}}</td>
              <td class="actions-col">
                <div class="action-buttons">
                  <button class="edit-button" (click)="openPaperForm(paper)" title="Editar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1l3 3-9 9-3 1 1-3z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                  <button class="delete-button" (click)="paper._id && deletePaper(paper._id)" title="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 5h10M5 5V3h6v2M5 5v8h6V5" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            
            <tr *ngIf="getPagePapers().length === 0">
              <td colspan="9" class="empty-state">
                <div class="empty-message">
                  <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" fill="none"/>
                    <path d="M14 2v6h6" stroke="currentColor" stroke-width="2"/>
                    <path d="M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <p>No se encontraron papers</p>
                  <button class="add-button" (click)="openPaperForm()">Agregar nuevo paper</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="pagination" *ngIf="filteredPapers.length > 0">
        <button 
          class="pagination-button" 
          [disabled]="currentPaperPage === 1" 
          (click)="changePaperPage(currentPaperPage - 1)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3l-4 5 4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        
        <div class="page-indicator">
          Página {{currentPaperPage}} de {{getTotalPaperPages()}}
        </div>
        
        <button 
          class="pagination-button" 
          [disabled]="currentPaperPage === getTotalPaperPages()" 
          (click)="changePaperPage(currentPaperPage + 1)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 3l4 5-4 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Contenido de la pestaña de Categorías de Academy -->
    <div class="tab-content" *ngIf="activeTab === 'academy-categories'">
      <div class="tab-header">
        <div class="tab-title">
          <h2>Categorías de Academy</h2>
          <p>Gestiona las categorías para los videos de Academy</p>
        </div>
        <button class="add-button" (click)="openAcademyCategoryForm()">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Nueva Categoría
        </button>
      </div>
      
      <div class="filters-bar">
        <div class="search-box">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input 
            type="text" 
            placeholder="Buscar categorías..." 
            [(ngModel)]="academyCategorySearchTerm"
            (input)="filterAcademyCategories()"
          >
        </div>
      </div>

      <div class="table-container">
        <table class="admin-table">
          <thead>
            <tr>
              <th class="category-id-col">ID</th>
              <th class="category-name-col">Nombre</th>
              <th class="category-description-col">Descripción</th>
              <th class="category-status-col">Estado</th>
              <th class="category-date-col">Fecha Creación</th>
              <th class="category-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let category of filteredAcademyCategories">
              <td class="category-id-col">#{{category.id}}</td>
              <td class="category-name-col">{{category.name}}</td>
              <td class="category-description-col">{{category.description || 'Sin descripción'}}</td>
              <td class="category-status-col">
                <span class="status-badge" [class]="category.status">
                  {{category.status === 'active' ? 'Activo' : 'Inactivo'}}
                </span>
              </td>
              <td class="category-date-col">{{category.createdAt | date:'dd/MM/yyyy'}}</td>
              <td class="category-actions-col">
                <div class="action-buttons">
                  <button class="edit-button" (click)="editAcademyCategory(category)" title="Editar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5 1l2.5 2.5L6 12.5 1 14l1.5-5L12.5 1z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                  <button class="delete-button" (click)="deleteAcademyCategory(category.id)" title="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 4h10M5 4V2.5A1.5 1.5 0 0 1 6.5 1h3A1.5 1.5 0 0 1 11 2.5V4m1 0v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Contenido de la pestaña de Categorías de Expertos -->
    <div class="tab-content" *ngIf="activeTab === 'expert-categories'">
      <div class="tab-header">
        <div class="tab-title">
          <h2>Categorías de Expertos</h2>
          <p>Gestiona las categorías para los expertos de la plataforma</p>
        </div>
        <button class="add-button" (click)="openExpertCategoryForm()">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Nueva Categoría
        </button>
      </div>
      
      <div class="filters-bar">
        <div class="search-box">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5" fill="none"/>
            <path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input 
            type="text" 
            placeholder="Buscar categorías de expertos..." 
            [(ngModel)]="expertCategorySearchTerm"
            (input)="filterExpertCategories()"
          >
        </div>
      </div>

      <div class="table-container">
        <table class="admin-table">
          <thead>
            <tr>
              <th class="category-id-col">ID</th>
              <th class="category-name-col">Nombre</th>
              <th class="category-description-col">Descripción</th>
              <th class="category-status-col">Estado</th>
              <th class="category-date-col">Fecha Creación</th>
              <th class="category-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let category of filteredExpertCategories">
              <td class="category-id-col">#{{category.id}}</td>
              <td class="category-name-col">{{category.name}}</td>
              <td class="category-description-col">{{category.description || 'Sin descripción'}}</td>
              <td class="category-status-col">
                <span class="status-badge" [class]="category.status">
                  {{category.status === 'active' ? 'Activo' : 'Inactivo'}}
                </span>
              </td>
              <td class="category-date-col">{{category.createdAt | date:'dd/MM/yyyy'}}</td>
              <td class="category-actions-col">
                <div class="action-buttons">
                  <button class="edit-button" (click)="editExpertCategory(category)" title="Editar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5 1l2.5 2.5L6 12.5 1 14l1.5-5L12.5 1z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                  <button class="delete-button" (click)="deleteExpertCategory(category.id)" title="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 4h10M5 4V2.5A1.5 1.5 0 0 1 6.5 1h3A1.5 1.5 0 0 1 11 2.5V4m1 0v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4" stroke="currentColor" stroke-width="1.5" fill="none"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  
  <!-- Modal para agregar/editar video -->
  <div class="modal-overlay" *ngIf="showVideoForm">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{editMode ? 'Editar' : 'Agregar'}} Video</h2>
        <button class="close-button" (click)="closeVideoForm()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="video-title">Título *</label>
          <input 
            type="text" 
            id="video-title" 
            [(ngModel)]="videoForm.title" 
            placeholder="Título del video"
            required
          >
        </div>
        
        <div class="form-group">
          <label for="video-description">Descripción *</label>
          <textarea 
            id="video-description" 
            [(ngModel)]="videoForm.description" 
            placeholder="Descripción del video"
            rows="4"
            required
          ></textarea>
        </div>
        
        <div class="form-group">
          <label for="video-url">URL del Video *</label>
          <input 
            type="text" 
            id="video-url" 
            [(ngModel)]="videoForm.videoUrl" 
            placeholder="Ej: https://www.youtube.com/watch?v=..."
            required
          >
          <small>Ingresa la URL de YouTube del video.</small>
        </div>
        
        <div class="form-group">
          <label for="video-thumbnail">URL de la Miniatura</label>
          <input 
            type="text" 
            id="video-thumbnail" 
            [(ngModel)]="videoForm.thumbnailUrl" 
            placeholder="URL de la imagen de miniatura"
          >
          <small>Deja en blanco para usar la miniatura de YouTube por defecto.</small>
        </div>
        
        <div class="form-group">
          <label for="video-duration">Duración (MM:SS) *</label>
          <input 
            type="text" 
            id="video-duration" 
            [(ngModel)]="videoForm.duration" 
            placeholder="Ejemplo: 05:30"
            required
          >
          <small>Ingresa la duración del video en formato minutos:segundos.</small>
        </div>
        
        <div class="form-group">
          <label for="video-category">Categoría *</label>
          <select 
            id="video-category" 
            [(ngModel)]="videoForm.category"
            required
          >
            <option *ngFor="let category of videoCategories" [value]="category.id">{{category.name}}</option>
          </select>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="video-price">Precio (S/.)</label>
            <input 
              type="number" 
              id="video-price" 
              [(ngModel)]="videoForm.price" 
              min="0"
              [disabled]="videoForm.isFree || false"
            >
          </div>
          
          <div class="form-group checkbox-group">
            <label>
              <input 
                type="checkbox" 
                [(ngModel)]="videoForm.isFree"
              >
              Gratis
            </label>
          </div>
        </div>
        
        <div class="form-group checkbox-group">
          <label>
            <input 
              type="checkbox" 
              [(ngModel)]="videoForm.featured"
            >
            Destacar este video
          </label>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closeVideoForm()">Cancelar</button>
        <button class="save-button" (click)="saveVideo()">{{editMode ? 'Actualizar' : 'Guardar'}} Video</button>
      </div>
    </div>
  </div>

  <!-- Modal para agregar/editar paper -->
  <div class="modal-overlay" *ngIf="showPaperForm">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{editPaperMode ? 'Editar' : 'Agregar'}} Paper</h2>
        <button class="close-button" (click)="closePaperForm()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="paper-title">Título *</label>
          <input 
            type="text" 
            id="paper-title" 
            [(ngModel)]="paperForm.title" 
            placeholder="Título del paper"
            required
          >
        </div>
        
        <div class="form-group">
          <label for="paper-description">Descripción *</label>
          <textarea 
            id="paper-description" 
            [(ngModel)]="paperForm.description" 
            placeholder="Descripción del paper"
            rows="4"
            required
          ></textarea>
        </div>
        
        <div class="form-group">
          <label for="paper-author">Autor *</label>
          <select 
            id="paper-author" 
            [(ngModel)]="paperForm.author" 
            required
            class="form-select"
          >
            <option value="" disabled>Seleccionar experto o mentor</option>
            <option 
              *ngFor="let expert of activeExperts" 
              [value]="expert._id"
            >
              {{expert.firstName}} {{expert.lastName}} - {{expert.email}} ({{expert.type?.name}})
            </option>
          </select>
          <!-- Debug temporal -->
          <small style="color: #666; font-size: 12px;">
            Debug: {{activeExperts.length}} expertos y mentores cargados
            <span *ngIf="activeExperts.length === 0" style="color: red;">- No hay expertos o mentores disponibles</span>
          </small>
        </div>
        
        <div class="form-group">
          <label for="paper-file">Archivo PDF *</label>
          <input 
            type="file" 
            id="paper-file" 
            accept=".pdf"
            (change)="onPaperFileSelected($event)"
            required
          >
          <small>Sube el archivo PDF del paper.</small>
          <div *ngIf="selectedPdfFile" class="file-selected">
            <span class="file-name">✓ {{selectedPdfFile.name}}</span>
          </div>
        </div>
        
        <div class="form-group">
          <label for="paper-cover">Portada</label>
          <input 
            type="file" 
            id="paper-cover" 
            accept="image/*"
            (change)="onPaperCoverSelected($event)"
          >
          <small>Sube una imagen de portada para el paper.</small>
          <div *ngIf="selectedCoverFile" class="file-selected">
            <span class="file-name">✓ {{selectedCoverFile.name}}</span>
          </div>
        </div>
        
        <div class="form-group">
          <label for="paper-pages">Número de Páginas *</label>
          <input 
            type="number" 
            id="paper-pages" 
            [(ngModel)]="paperForm.pages" 
            min="1"
            placeholder="Ejemplo: 25"
            required
          >
        </div>
        
        <div class="form-group">
          <label for="paper-category">Categorías * (máximo 4)</label>
          <div class="multiselect-container">
            <div class="selected-categories" *ngIf="paperForm.categories && paperForm.categories.length > 0">
              <span class="category-tag" *ngFor="let categoryId of paperForm.categories; let i = index">
                {{ getCategoryNameById(categoryId) }}
                <button type="button" class="remove-category" (click)="removeCategory(i)" aria-label="Eliminar categoría">
                  ×
                </button>
              </span>
            </div>
            <div class="multiselect-dropdown" [class.open]="categoryDropdownOpen">
              <button 
                type="button" 
                class="multiselect-trigger"
                (click)="toggleCategoryDropdown(); $event.stopPropagation()"
                [disabled]="paperForm.categories && paperForm.categories.length >= 4"
              >
                <span *ngIf="!paperForm.categories || paperForm.categories.length === 0">
                  Seleccionar categorías
                </span>
                <span *ngIf="paperForm.categories && paperForm.categories.length > 0 && paperForm.categories.length < 4">
                  Agregar más categorías ({{ paperForm.categories.length }}/4)
                </span>
                <span *ngIf="paperForm.categories && paperForm.categories.length >= 4">
                  Máximo alcanzado (4/4)
                </span>
                <span class="dropdown-arrow">▼</span>
              </button>
              <div class="multiselect-options" *ngIf="categoryDropdownOpen">
                <div 
                  class="multiselect-option" 
                  *ngFor="let category of paperCategories"
                  [class.disabled]="isCategorySelected(category.id)"
                  (click)="toggleCategory(category.id); $event.stopPropagation()"
                >
                  <input 
                    type="checkbox" 
                    [checked]="isCategorySelected(category.id)"
                    [disabled]="!isCategorySelected(category.id) && paperForm.categories && paperForm.categories.length >= 4"
                    (change)="toggleCategory(category.id)"
                  >
                  <label>{{ category.name }}</label>
                </div>
                <div class="no-categories" *ngIf="paperCategories.length === 0">
                  No hay categorías disponibles
                </div>
              </div>
            </div>
            <div class="category-error" *ngIf="categoryError">
              {{ categoryError }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="paper-tags">Etiquetas</label>
          <input 
            type="text" 
            id="paper-tags" 
            [(ngModel)]="paperForm.tags" 
            placeholder="Etiqueta 1, Etiqueta 2, Etiqueta 3"
          >
          <small>Separa las etiquetas con comas.</small>
        </div>

        <div class="form-group">
          <label for="paper-learning-objectives">Objetivos de Aprendizaje</label>
          <textarea 
            id="paper-learning-objectives" 
            [(ngModel)]="paperForm.learningObjectives" 
            placeholder="• Objetivo 1&#10;• Objetivo 2&#10;• Objetivo 3"
            rows="4"
          ></textarea>
          <small>Lista los objetivos de aprendizaje del paper.</small>
        </div>

        <!-- <div class="form-group">
          <label for="paper-summary">Resumen Ejecutivo</label>
          <textarea 
            id="paper-summary" 
            [(ngModel)]="paperForm.summary" 
            placeholder="Resumen ejecutivo del paper"
            rows="3"
          ></textarea>
          <small>Breve resumen del contenido del paper.</small>
        </div> -->

        <div class="form-group">
          <label for="paper-content">Contenido Completo</label>
          <textarea 
            id="paper-content" 
            [(ngModel)]="paperForm.content" 
            placeholder="Contenido completo del paper"
            rows="6"
          ></textarea>
          <small>Contenido completo del paper (opcional si se sube archivo PDF).</small>
        </div>

        <div class="form-group">
          <label for="paper-keywords">Palabras Clave</label>
          <input 
            type="text" 
            id="paper-keywords" 
            [(ngModel)]="paperForm.keywords" 
            placeholder="palabra1, palabra2, palabra3"
          >
          <small>Palabras clave separadas por comas.</small>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="paper-language">Idioma</label>
            <select 
              id="paper-language" 
              [(ngModel)]="paperForm.language"
            >
              <option value="es">Español</option>
              <option value="en">Inglés</option>
              <option value="pt">Portugués</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="paper-year">Año de Publicación</label>
            <input 
              type="number" 
              id="paper-year" 
              [(ngModel)]="paperForm.year" 
              min="1900"
              max="2030"
            >
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="paper-isbn">ISBN</label>
            <input 
              type="text" 
              id="paper-isbn" 
              [(ngModel)]="paperForm.isbn" 
              placeholder="978-1234567890"
            >
          </div>
          
          <div class="form-group">
            <label for="paper-publisher">Editorial</label>
            <input 
              type="text" 
              id="paper-publisher" 
              [(ngModel)]="paperForm.publisher" 
              placeholder="Nombre de la editorial"
            >
          </div>
        </div>

        <div class="form-group">
          <label for="paper-published-date">Fecha de Publicación</label>
          <input 
            type="date" 
            id="paper-published-date" 
            [(ngModel)]="paperForm.publishedDate"
          >
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="paper-price">Precio (S/.)</label>
            <input 
              type="number" 
              id="paper-price" 
              [(ngModel)]="paperForm.price" 
              min="0"
              [disabled]="paperForm.isFree"
            >
          </div>
          
          <div class="form-group checkbox-group">
            <label>
              <input 
                type="checkbox" 
                [(ngModel)]="paperForm.isFree"
              >
              Gratis
            </label>
          </div>
        </div>
        
        <div class="form-group">
          <label for="paper-status">Estado *</label>
          <select 
            id="paper-status" 
            [(ngModel)]="paperForm.status"
            required
            class="form-select"
          >
            <option [value]="1">Activo</option>
            <option [value]="2">Inactivo</option>
            <option [value]="3">En revision</option>
            <option [value]="4">Borrador</option>
          </select>
          <small style="color: #666; font-size: 12px;">
            Selecciona el estado del paper
          </small>
        </div>
        
        <div class="form-group checkbox-group">
          <label>
            <input 
              type="checkbox" 
              [(ngModel)]="paperForm.featured"
            >
            Destacar este paper
          </label>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closePaperForm()">Cancelar</button>
        <button class="save-button" (click)="savePaper()">{{editPaperMode ? 'Actualizar' : 'Guardar'}} Paper</button>
      </div>
    </div>
  </div>

  <!-- Modal para previsualizar video -->
  <div class="modal-overlay" *ngIf="showVideoPreview">
    <div class="modal-content video-preview-modal">
      <div class="modal-header">
        <h2>Previsualización de Video</h2>
        <button class="close-button" (click)="closeVideoPreview()">×</button>
      </div>
      
      <div class="video-preview-container">
        <iframe 
          *ngIf="previewVideoUrl" 
          [src]="previewVideoUrl" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closeVideoPreview()">Cerrar</button>
      </div>
    </div>
  </div>

  <!-- Modal para previsualizar paper -->
  <div class="modal-overlay" *ngIf="showPaperPreview">
    <div class="modal-content paper-preview-modal">
      <div class="modal-header">
        <h2>Previsualización de Paper</h2>
        <button class="close-button" (click)="closePaperPreview()">×</button>
      </div>
      
      <div class="paper-preview-container">
        <div class="paper-info">
          <h3>{{previewPaper?.title}}</h3>
          <p><strong>Autor:</strong> {{getExpertName(previewPaper?.author || '')}}</p>
          <p><strong>Páginas:</strong> {{previewPaper?.pages}}</p>
          <p><strong>Categorías:</strong> 
            <span 
              class="category-tag-small" 
              *ngFor="let category of getPaperCategoriesArray(previewPaper)"
              [title]="category.name"
            >
              {{category.name}}
            </span>
            <span *ngIf="getPaperCategoriesArray(previewPaper).length === 0">
              Sin categoría
            </span>
          </p>
          <p>{{previewPaper?.description}}</p>
        </div>
        <div class="paper-cover">
          <img [src]="getPaperCoverUrl(previewPaper?.coverUrl)" alt="Portada del paper">
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closePaperPreview()">Cerrar</button>
        <button class="download-button" (click)="downloadPaper(previewPaper)">Descargar PDF</button>
      </div>
    </div>
  </div>

  <!-- Modal para agregar/editar categoría de Academy -->
  <div class="modal-overlay" *ngIf="showAcademyCategoryForm">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{editAcademyCategoryMode ? 'Editar' : 'Agregar'}} Categoría de Academy</h2>
        <button class="close-button" (click)="closeAcademyCategoryForm()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="academy-category-name">Nombre de la Categoría *</label>
          <input 
            type="text" 
            id="academy-category-name" 
            [(ngModel)]="academyCategoryForm.name" 
            placeholder="Ej: Desarrollo Personal"
            required
          >
        </div>
        
        <div class="form-group">
          <label for="academy-category-description">Descripción</label>
          <textarea 
            id="academy-category-description" 
            [(ngModel)]="academyCategoryForm.description" 
            placeholder="Descripción de la categoría..."
            rows="3"
          ></textarea>
        </div>
        
        <div class="form-group">
          <label for="academy-category-status">Estado</label>
          <select 
            id="academy-category-status" 
            [(ngModel)]="academyCategoryForm.status"
          >
            <option value="active">Activo</option>
            <option value="inactive">Inactivo</option>
          </select>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closeAcademyCategoryForm()">Cancelar</button>
        <button class="save-button" (click)="saveAcademyCategory()">{{editAcademyCategoryMode ? 'Actualizar' : 'Guardar'}} Categoría</button>
      </div>
    </div>
  </div>

  <!-- Modal para agregar/editar categoría de Expertos -->
  <div class="modal-overlay" *ngIf="showExpertCategoryForm">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{editExpertCategoryMode ? 'Editar' : 'Agregar'}} Categoría de Expertos</h2>
        <button class="close-button" (click)="closeExpertCategoryForm()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="expert-category-name">Nombre de la Categoría *</label>
          <input 
            type="text" 
            id="expert-category-name" 
            [(ngModel)]="expertCategoryForm.name" 
            placeholder="Ej: Bienestar y Salud"
            required
          >
        </div>
        
        <div class="form-group">
          <label for="expert-category-description">Descripción</label>
          <textarea 
            id="expert-category-description" 
            [(ngModel)]="expertCategoryForm.description" 
            placeholder="Descripción de la categoría..."
            rows="3"
          ></textarea>
        </div>
        
        <div class="form-group">
          <label for="expert-category-status">Estado</label>
          <select 
            id="expert-category-status" 
            [(ngModel)]="expertCategoryForm.status"
          >
            <option value="active">Activo</option>
            <option value="inactive">Inactivo</option>
          </select>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-button" (click)="closeExpertCategoryForm()">Cancelar</button>
        <button class="save-button" (click)="saveExpertCategory()">{{editExpertCategoryMode ? 'Actualizar' : 'Guardar'}} Categoría</button>
      </div>
    </div>
  </div>
</div> 